export default __webpack_public_path__ + "static/media/myclassic0.2b2c3b27.png";